<!--
 * @Description: 合同信息
 * @Author: kanjiahao
 * @Date: 2025-1-10
 -->
<template>
  <div class="settle-manager"
       @keyup.enter="enterSearch">
    <el-form ref="form"
             :model="form"
             inline
             class="table-search-bar"
             label-width="70px">
      <el-form-item label="供应商"
                    prop="supplierName">
        <el-input v-model="form.supplierName"
                  placeholder="请输入供应商名称"></el-input>
      </el-form-item>
      <el-form-item label="合同号"
                    prop="contractNo">
        <el-input v-model="form.contractNo"
                  placeholder="请输入合同号"></el-input>
      </el-form-item>
      <el-form-item label="合同类型"
                    prop="contractType">
        <el-select v-model="form.contractType"
                   placeholder="请选择合同类型"
                   clearable>
          <el-option v-for="item in contractTypeOptions"
                     :key="item.value"
                     :label="item.value"
                     :value="item.value">
          </el-option> </el-select>
      </el-form-item>
      <el-form-item label="状态"
                    prop="status">
        <el-select v-model="form.status"
                   placeholder="请选择状态"
                   clearable>
          <el-option v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option> </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   @click="handleSearch">搜索</el-button>
        <el-button type="primary"
                   @click="handleReset">重置</el-button>
        <el-button type="primary"
                   @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="contractInfoList"
              style="width: 100%"
              tooltip-effect="light"
              border
              resizable>
      <el-table-column prop="contractNo"
                       width="240"
                       label="合同号"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="contractType"
                       label="合同类型"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="supplierName"
                       label="供应商名称"
                       width="240"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="storeroomType"
                       label="库房类型"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="storeroomCode"
                       label="库房编码"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="storeroomName"
                       label="库房名称"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pileName"
                       label="料堆"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status"
                       label="状态"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          {{
            scope.row.status === 0
              ? '未分配'
              : scope.row.status === 1
                ? '已分配'
                : ''
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="150">
        <template slot-scope="scope">
          <el-button size="mini"
                     @click="handleEdit(scope.row)">编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="contractInfoListState.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="contractInfoListState.total"
                   :current-page="contractInfoListState.pageNo"
                   background>
    </el-pagination>
    <add-or-edit-dialog :show.sync="dialogVisible"
                        :info="printDialogInfo"
                        :LOV_CODE.sync="LOV_CODE">
    </add-or-edit-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import addOrEditDialog from '@/views/warehouseManager/flkContractInfo/addOrEditDialog.vue'

export default {
  name: 'flkContractInfo',
  components: {
    addOrEditDialog

  },
  data () {
    return {
      form: {
        status: 0
      },
      options: [
        {
          value: 0,
          label: '未分配'
        },
        {
          value: 1,
          label: '已分配'
        }
      ],
      contractTypeOptions: [
        {
          value: '采购'
        },
        {
          value: '销售'
        },
        {
          value: '调拨'
        }
      ],
      dialogVisible: false,
      printDialogInfo: {}
    }
  },
  computed: {
    ...mapGetters({
      contractInfoList: 'getContractInfoList',
      contractInfoListState: 'getContractInfoListState',
      LOV_CODE: 'LOV_CODE'
    })
  },
  methods: {
    ...mapActions([
      'getContractInfoList',
      'getStoreHouseData'
    ]),
    enterSearch (e) {
      // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const { supplierName, contractNo, status, contractType } =
        this.form
      const params = {
        supplierName,
        contractNo,
        status,
        contractType
      }
      this.getContractInfoList(params)
    },
    handleSizeChange (val) {
      this.getContractInfoList({ pageSize: val, pageNo: 1 })
    },
    handleCurrentChange (val) {
      this.getContractInfoList({ pageNo: val })
    },
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    handleAdd () {
      this.dialogVisible = true
      this.printDialogInfo = {}
    },
    handleEdit (row) {
      this.dialogVisible = true
      this.printDialogInfo = row
    }
  },
  mounted () {
    this.getStoreHouseData()
    this.handleSearch()
  }
}
</script>

<style scoped lang='scss'>
.upload-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
